<template>
  <div class="box">
    <form
      class="sign-in is-centered"
      @submit.prevent="onSubmit"
    >
      <img
        :src="logo"
        alt="logo"
      >
      <h1 class="title is-4 has-text-white">
        Recuperar Contraseña
      </h1>

      <template v-if="!sended">
        <AppInputEmail
          :value="email"
          :loading="loading"
          :disabled="loading"
          @input="onChangeEmail"
          @change="onChangeEmail"
        />

        <ButtonSubmit
          :loading="loading"
          :disabled="loading"
          text="recupera tu contraseña"
        />
      </template>

      <div
        v-else
        class="notification is-success"
      >
        Se envió un correo con un link para que puedas recuperar tu contraseña. <br>
        Por favor haz click en el enlace que viene en el correo.
      </div>

      <LinkSignIn />
    </form>
  </div>
</template>

<script>
import merge from 'lodash/merge';
import { createNamespacedHelpers, mapGetters } from 'vuex';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('auth');

export default {
  name: 'ForgottenPassword',
  components: {
    AppInputEmail: () => import(/* webpackChunkName: "app-input-email" */ '@/components/AppInputEmail.vue'),
    LinkSignIn: () => import(/* webpackChunkName: "auth-link-sign-in" */ '@/components/Auth/LinkSignIn.vue'),
    ButtonSubmit: () => import(/* webpackChunkName: "auth-button-submit" */ '@/components/Auth/ButtonSubmit.vue'),
  },
  data() { return { loading: false, sended: false }; },
  computed: merge(
    mapState({ email: ({ email }) => email }),
    mapGetters({ logo: 'ui/authLogo' }),
  ),
  methods: merge(
    mapMutations(['setValue']),
    mapActions(['forgottenPassword']),
    {
      onChangeEmail(event) {
        const { name: accessor, value } = event.target;

        this.setValue({ accessor, value });
      },
      async onSubmit() {
        this.loading = true;

        try {
          await this.forgottenPassword();

          this.sended = true;
        } catch ({ message }) {
          this.$danger({ message });
        }

        this.loading = false;
      },
    },
  ),
};
</script>

<style scoped>
.box {
  padding: 3rem;
}

@media screen and (min-width: 769px) {
  form {
    width: 500px;
  }
}
</style>
